import React, { useEffect, useState } from 'react';

const Icon = ({ name, className = '', onClick, color = '#000000', size = 24 }) => {
    const [spriteLoaded, setSpriteLoaded] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadSprite = async () => {
            try {
                if (!window.hangtagDesignerData?.spriteUrl) {
                    console.error('Sprite URL bulunamadı');
                    setError('Sprite URL bulunamadı');
                    return;
                }

                // Sprite zaten yüklenmiş mi kontrol et
                if (document.querySelector('div[data-sprite-container]')) {
                    setSpriteLoaded(true);
                    return;
                }

                const response = await fetch(window.hangtagDesignerData.spriteUrl);
                if (!response.ok) {
                    throw new Error(`Sprite yüklenemedi: ${response.statusText}`);
                }

                const spriteText = await response.text();
                const div = document.createElement('div');
                div.setAttribute('data-sprite-container', 'true');
                div.style.display = 'none';
                div.innerHTML = spriteText;
                document.body.appendChild(div);
                setSpriteLoaded(true);
            } catch (err) {
                console.error('Sprite yükleme hatası:', err);
                setError(err.message);
            }
        };

        loadSprite();

        return () => {
            // Cleanup: Sprite'ı kaldırma işlemini kaldırdık çünkü sprite'ı sayfa yenilenene kadar tutmak istiyoruz
        };
    }, []);

    if (error) {
        console.error('Icon error:', error);
        return null;
    }

    if (!spriteLoaded) {
        return null;
    }

    return (
        <svg 
            className={`icon ${className}`} 
            onClick={onClick}
            width={size}
            height={size}
            style={{ color: color }}
        >
            <use xlinkHref={`#${name}`} />
        </svg>
    );
};

export default Icon;